
document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.scroll-to-top')
		.forEach(node => {
			node.addEventListener('click', event => {
				event.preventDefault();
				window.scroll({
					top: 0,
					left: 0,
					behavior: 'smooth'
				});
				return false;
			});
		});
});
